import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {DataObjectId} from 'yougile-model'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {crmStore} from '@components/crm/crm-store'
import {bgMixin} from '@components/main-menu/mixins'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {DragControl, dragPropsFromCtl} from '@containers/hooks-draggable'
import {cn} from '@containers/html-utils'
import {globals} from '@extensions/globals-base'
import {ProjectProxy} from '@extensions/proxies/project-proxy'
import {gotoProject} from '../handlers/main-handlers'
import {useMainMenuStore} from '../main-menu-store'

type TwProjectItemType = {
  $dragged: boolean
  $dragOver: boolean
  $active: boolean
}
const TwProjectItem = tw.div<TwProjectItemType>`
  relative
  isolate
  
  flex
  items-center
  justify-between

  pl-36
  pr-12
  min-h-[30px]
  max-h-[30px]

  text-12
  leading-4

  rounded-4

  ${p =>
    cn(
      bgMixin(p.$active),
      p.$active
        ? cn('cursor-default', 'text-panel-text-primary')
        : cn('cursor-pointer', 'text-panel-text-secondary'),
      p.$dragged && 'opacity-50',
      p.$dragOver && `border-0 border-solid border-t-2 border-action-default`
    )}
`

export const ProjectsItem = observer(
  ({
    p,
    dragCtl
  }: {
    p: ProjectProxy
    dragCtl: DragControl<DataObjectId | 'bottom'>
  }) => {
    const [state] = useMainMenuStore()
    const {currentPage, currentProject} = state
    const forceUpdate = useForceUpdate()
    useSyncEvent(
      'profile',
      {debounceTime: 50, filter: globals.currentUserId},
      () => {
        forceUpdate()
      }
    )
    return (
      <TwProjectItem
        $active={currentPage === 'board' && currentProject?.id === p.projectId}
        $dragOver={
          dragCtl.dragOverId === p.projectId &&
          dragCtl.draggedId !== p.projectId
        }
        $dragged={dragCtl.draggedId === p.projectId}
        draggable
        onClick={() => {
          gotoProject(p.projectId)
          void Tracking.send(TrackingEvent.leftPanelProjectClick)
        }}
        {...dragPropsFromCtl(p.projectId, dragCtl)}
      >
        <div className="truncate">{p.projectName}</div>
        {p.projectType === 'crm' && crmStore.isCrmEnabled && (
          <div className="bg-disabled-new text-secondary px-4 rounded-4 font-semibold text-10">
            CRM
          </div>
        )}
      </TwProjectItem>
    )
  }
)
